export default __webpack_public_path__ + "static/media/arrow-right.b58e49cc.svg";